import stylesBreakpoint from 'common/styles/styles.breakpoint';
import { themedStyled } from 'common/styles/styletron.theme';

const styles = {
  common: { display: 'flex', marginTop: '8px', marginBottom: '8px' },
};

export const FormContent = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  marginTop: '-16px',
  marginLeft: '-16px',
  marginRight: '-16px',
  paddingTop: '16px',
  paddingLeft: '16px',
  paddingRight: '16px',
  overflow: 'scroll',
}));

export const DetailsCardHeader = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  [$theme.mediaQuery.md]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
}));

export const OtherContainer = themedStyled('div', {
  display: 'flex',
  justifyContent: 'space-between',
});

export const Container = themedStyled('div', {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

export const FormDivider = themedStyled('div', {
  marginTop: '120px',
});

export const SummaryContent = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'white',
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 199,
  boxShadow: '0px -4px 16px rgba(0, 0, 0, 0.12)',
  borderRadius: '8px 8px 0px 0px',
  padding: '16px',
  [$theme.mediaQuery.md]: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
}));

export const SummaryLeftContainer = themedStyled('div', {
  display: 'flex',
  alignItems: 'center',
});

export const SummaryRightContainer = themedStyled(
  SummaryLeftContainer,
  ({ $theme }) => ({
    marginTop: '16px',
    justifyContent: 'space-between',
    gap: '24px',
    [$theme.mediaQuery.md]: {
      flex: 0,
      marginTop: 0,
    },
  }),
);

export const FullContainer = themedStyled('div', {
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  [`@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`]: {
    flexDirection: 'column',
  },
});

export const ActivityContent = themedStyled('div', {
  paddingLeft: '24px',
  display: 'flex',
});

export const ActivityContainer = themedStyled('div', {
  ...styles.common,
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const TotalContent = themedStyled('div', {
  display: 'flex',
  justifyContent: 'end',
});

export const TotalItemContent = themedStyled('div', ({ $theme }) => ({
  ...styles.common,
  justifyContent: 'space-between',
  alignItems: 'center',
  minWidth: '100%',
  [$theme.mediaQuery.md]: {
    minWidth: '50%',
    maxWidth: '500px',
  },
}));
